import { useAppStoreStore } from '@/stores/appstore.store';
import { useOrganizationTeamStore } from '@/stores/organizationTeam.store';

export const getOranizationIdTeamId = () => {
  const organizations = useOrganizationTeamStore.getState().organizations;
  const appStores = useAppStoreStore.getState().appStores;
  const appStoreId = Object.keys(appStores)[0];

  // organizationId와 teamId를 한 번에 찾기
  const organization = organizations.find((org) => org.teamAppUserStoresInfo?.some((teamInfo) => teamInfo.storeId === Number(appStoreId)));

  const team = organization?.teamAppUserStoresInfo?.find((teamInfo) => teamInfo.storeId === Number(appStoreId));

  return {
    matchedOrganizationId: organization?.organizationId,
    matchedTeamId: team?.teamId
  };
};
